import httpService from '@/utils/request'
import { contextPath } from '@/config/'

// 获取详情数据总揽接口
export const getStatTotalBySpiderIdApi = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/item/statTotalBySpiderId',
    method: 'get',
    params
  })
}

// 获取详情数据30天统计
export const getStat30BySpiderIdApi = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/item/statByDay',
    method: 'get',
    params
  })
}

// 获取详情数据30天统计
export const getSpiderDetailById = (params) => {
  return httpService({
    url: contextPath + '/spider/item',
    method: 'get',
    params
  })
}

// 统计分析，顶部任务数
export const getTaskNumById = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/taskNumBySpiderId',
    method: 'get',
    params
  })
}

// 统计分析，顶部结果数
export const getResulNumtById = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/resultNumBySpiderId',
    method: 'get',
    params
  })
}



// 历史人物统计
export const statsByDayTaskNum = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/statsByDayTaskNum',
    method: 'get',
    params
  })
}

// 历史采集统计
export const parseStatsDetailBySpiderId = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/parseStatsDetailBySpiderId',
    method: 'get',
    params
  })
}
